import React, { useEffect, useState, useRef } from "react";
import DataTablePaginationServer from "../../../Components/DataTable/DataTablePaginationServer";
import { ButtonAdd, ButtonEdit, ButtonDelete} from "../../../Components/Button/Button";
import AddDocumentRecordDaily from "./AddDocumentRecordDaily";
import Loading from "../../../Components/Loading/Loading";
import { useRecoilValue, useRecoilState } from "recoil";
import { userData } from "../../../DataContext/DataContext";
import {
  AlertError,
  AlertSuccess,
  AlertWarning,
} from "../../../Components/AlertDialog/AlertDialog";
import axios from "axios";
import { authorization, UrlApi } from "../../../UrlApi/UrlApi";
import Card from "@mui/material/Card";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import DateRange from "../../../Components/DateRange/DateRange";
import { TextInput } from "../../../Components/Input/Input";
import moment from "moment/moment";
import { InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { ButtonOther } from "../../../Components/Button/Button";
import ImgExcell from "../../../Assets/Images/excel.png";
import * as SiIcons from "react-icons/si";
import RefreshIcon from "@mui/icons-material/Refresh";
import CancelIcon from "@mui/icons-material/Cancel";
import ExportExcel from "../../../Components/ExportExcel/ExportExcel";
import { AlertConfirm } from "../../../Components/AlertDialog/AlertDialog";

function DocumentRecordDaily(props) {
    const user = useRecoilValue(userData);
    const [openDialogformEdit, setOpenDialogformEdit] = useState(false);
    const [openDialogformAdd, setOpenDialogformAdd] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadData, setLoadData] = useState(false);
    const [documentData, setDocumentData] = useState([]);
    const refContainer = useRef(null);
    const [date, setDate] = useState([
      {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
    ]);
    const tableRef = useRef();
    const [variable, setVariable] = useState({
        startDate : new Date(),
        endDate : new Date(),
        search: "",
        documentData: [],
        documentId: "",
        page: 0,
        pageSize: 50,
        countRowData: 0
    });
  
  const getData = async (page, pageSize, startDate, endDate, search) => {
    const url =
      UrlApi +
      `get_record_daily_entry?page=${page}
                          &page_size=${pageSize}
                          &start_date=${moment(startDate).format("YYYY-MM-DD")}
                          &end_date=${moment(endDate).format("YYYY-MM-DD")}
                          &search=${search}`;
    await axios
      .get(url, authorization)
      .then((res) => {
        if (res.data.length > 0) {
            variable.countRowData = res.data[0].count_row_data
        }else{
            variable.countRowData = 0;
        }
        setDocumentData(res.data);
      })
      .catch((err) => {
        AlertError(err);
      });
  };

  const deleteDocument = async (documentId) =>{
    setLoading(true);
    setLoadData(false);
    await axios
      .post(UrlApi + "delete_document_record", {document_id: documentId}, authorization)
      .then((res) => {
        AlertSuccess(res.data.message, ()=>{}, 2000);
        setLoadData(true);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        AlertError(err);
      });
  }

  useEffect(() => {
    document.addEventListener("keydown", detextKeyDown, true);
    getData(variable.page, variable.pageSize, variable.startDate, variable.endDate, variable.search);
  }, [openDialogformAdd === false, openDialogformEdit === false, loadData]);

  const detextKeyDown = (e) => {
    if (e.key === "F9") {
      variable.openDialogformAdd = true;
      return false;
    }
  };

  const columns = [
    {
      title: "ลบ",
      field: "document_record_daily_id",
      filtering: false,
      export: false,
      headerStyle: {
        width: 1,
        maxWidth: 1,
      },
      cellStyle: { width: 1, maxWidth: 1 },
      render: (rowData) => (
        <ButtonDelete
          onClick={() => {
            AlertConfirm('ยืนยันการลบข้อมูลเอกสาร'+' : '+ rowData.listno_order, ()=>{
              deleteDocument(rowData.document_record_daily_id);
            });
          }}
        />
      ),
    },
    {
      title: "เปิด",
      field: "document_record_daily_id",
      filtering: false,
      export: false,
      headerStyle: {
        width: 1,
        maxWidth: 1,
      },
      cellStyle: { width: 1, maxWidth: 1 },
      render: (rowData) => (
        <ButtonEdit
          onClick={() => {
            variable.documentId = rowData.document_record_daily_id;
            setOpenDialogformEdit(true);
          }}
        />
      ),
    },
    {
      title: "ลำดับ",
      field: "list_no",
      filtering: false,
      headerStyle: {
        width: "10px",
        maxWidth: "10px",
      },
      cellStyle: { width: "5px", maxWidth: "5px" },
    },
    {
      title: "เลขที่ใบสั่ง",
      field: "listno_order",
      headerStyle: {
        width: "90%",
        maxWidth: "90%",
      },
      cellStyle: { width: "90%", maxWidth: "90%" },
    },
    // {
    //   title: "ชื่อพนักงาน",
    //   field: "emp_name",
    //   headerStyle: {
    //     width: "10%",
    //     maxWidth: "10%",
    //   },
    //   cellStyle: { width: "10%", maxWidth: "10%" },
    // },
    // {
    //   title: "Code Sales",
    //   field: "emp_code",
    //   height: 10,
    //   headerStyle: {
    //     width: "5%",
    //     maxWidth: "5%",
    //   },
    //   cellStyle: { width: "5%", maxWidth: "5%" },
    // },
    // {
    //   title: "ชื่อ Sales",
    //   field: "sale_name",
    //   height: 10,
    //   headerStyle: {
    //     width: "5%",
    //     maxWidth: "5%",
    //   },
    //   cellStyle: { width: "5%", maxWidth: "5%" },
    // },
    // {
    //   title: "พื้นที่สั่งาน (เขต)",
    //   field: "order_area_name",
    //   height: 10,
    //   headerStyle: {
    //     width: "5%",
    //     maxWidth: "5%",
    //   },
    //   cellStyle: { width: "5%", maxWidth: "5%" },
    // },
    // {
    //   title: "โซน",
    //   field: "zone_master_name",
    //   height: 10,
    //   headerStyle: {
    //     width: "10%",
    //     maxWidth: "10%",
    //   },
    //   cellStyle: { width: "10%", maxWidth: "10%" },
    // },
    // {
    //   title: "หมายเหตุ",
    //   field: "remark",
    //   height: 10,
    //   headerStyle: {
    //     width: "50%",
    //     maxWidth: "50%",
    //   },
    //   cellStyle: { width: "50%", maxWidth: "50%" },
    // },
  ];

  const HeaderPage = () => {
    return (
      <>
        <div style={{ paddingTop: "10px" }}>
          <label
            style={{ marginLeft: "10px", marginTop: "10px", fontSize: "18px" }}
          >
            บันทึกงานเข้าประจำวัน
          </label>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
              }}
            >
              {datePicker()}
             <div style={{marginLeft: '38px'}}>
              <ButtonAdd
                  label="เพิ่ม"
                  variant="contained"
                  onClick={() => {
                    setOpenDialogformAdd(true);
                  }}
                />
             </div>
              <ButtonOther
                  onClick={() => {
                    getData(variable.page, variable.pageSize, variable.startDate, variable.endDate, variable.search);
                  }}
                  message="โหลดข้อมูลใหม่"
                  width="20ch"
                  startIcon={<RefreshIcon />}
                  background="#61C495"
                />
            </div>
            <div
              style={{
                display: "flex",
              }}
            >
              <div style={{ marginRight: "12px", marginTop: "2px" }}>
                <TextInput
                  width="100%"
                  placeholder="ค้นหา เลขที่บิล, ชื่อ Sales"
                  onKeyDown={(e) => {}}
                  value={variable.search}
                  onChange={(e) => {
                    if(e.target.value === ""){
                      variable.page = 0;
                    }
                    variable.search = e.target.value;
                    getData(variable.page, variable.pageSize, variable.startDate, variable.endDate, e.target.value);                          
                  }}
                  startAdornment={
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  }
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => {
                          variable.search = "";
                          variable.page = 0;
                          getData(0, variable.pageSize, variable.startDate, variable.endDate, "");  
                        }}
                        edge="end"
                      >
                        <CancelIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </div>
              {
                <ButtonOther
                  onClick={() => {
                    exportExcells();
                  }}
                  message="ส่งออก"
                  width="15ch"
                  startIcon={<SiIcons.SiMicrosoftexcel />}
                  
                />
              }
            </div>
          </div>
        </div>
      </>
    );
  };

  function datePicker() {
    return (
      <>
        <DateRange
          onClick={(date) => {
            variable.startDate = date[0].startDate;
            variable.endDate = date[0].endDate;
            getData(variable.page, variable.pageSize, date[0].startDate, date[0].endDate, variable.search);
          }}
        />
      </>
    );
  }

  // const exportExcells = () => {
  //   let columnExport = [];
  //   columns.map((item) => {
  //     if (item.title !== "เปิด" && item.title !== "ลบ") {
  //       columnExport.push(item.title);
  //     }
  //   });

  //   const header = [
  //     "",
  //     "รายงานประจำวันที่ " +
  //       moment(date[0].startDate).format("DD/MM/YYYY") +
  //       " ถึง " +
  //       moment(date[0].endDate).format("DD/MM/YYYY"),
  //   ];
  //   const data = documentData.map((item) => {
  //     return [
  //       item.list_no,
  //       item.listno_order,
  //       item.emp_name,
  //       item.emp_code,
  //       item.sale_name,
  //       item.order_area_name,
  //       item.zone_master_name,
  //       item.remark
  //     ];
  //   });
  //   ExportExcel(
  //     data,
  //     columnExport,
  //     "ข้อมูลงานเข้าประจำวัน DGF Express",
  //     "ข้อมูลงานเข้าประจำวัน DGF Express.xlsx",
  //     header,
  //   );
  // };
  const columnsExport = [
    {
      title: "ลำดับ",
    },
    {
      title: "เลขที่ใบสั่ง",
    },
    {
      title: "ชื่อพนักงาน",
    },
    {
      title: "Code Sales",
    },
    {
      title: "ชื่อ Sales",
    },
    {
      title: "พื้นที่สั่งาน (เขต)",
    },
    {
      title: "โซน",
    },
    {
      title: "หมายเหตุ",
    },
  ];

  const exportExcells = async () => {
    const workSheetColumnsName = columnsExport.map((item) => {
      return [
        item.title
      ];
    });
  
    setLoading(true);
    await axios
      .get(
        UrlApi +
        `get_record_daily_entry_export?page=${variable.page}
                          &page_size=${variable.pageSize}
                          &start_date=${moment(variable.startDate).format("YYYY-MM-DD")}
                          &end_date=${moment(variable.endDate).format("YYYY-MM-DD")}
                          &search=${variable.search}`,
        authorization
      )
      .then((res) => {
        if (res.data.length > 0) {
          const header = [
            "",
            "รายงานประจำวันที่" +
              moment(variable.startDate).format("DD/MM/YYYY") +
              " ถึง " +
              moment(variable.endDate).format("DD/MM/YYYY")
          ];
          const data = res.data.map((item) => {
            return [
              item.list_no,
              item.listno_order,
              item.emp_name,
              item.emp_code,
              item.sale_name,
              item.order_area_name,
              item.zone_master_name,
              item.remark
            ];
          });
          ExportExcel(
            data,
            workSheetColumnsName,
            "ข้อมูลงานเข้าประจำวัน DGF Express",
            "ข้อมูลงานเข้าประจำวัน DGF Express.xlsx",
            header,
          );
          setLoading(false);
        } else {
          setLoading(false);
          AlertWarning("ไม่พบข้อมูลที่ต้องการส่งออก");
        }
      })
      .catch((err) => {
        AlertError(err);
      });
  };


  return (
    <>
      {/* <label>บันทึกรายละเอียดงานประจำวัน</label> */}
      <Card
        variant="outlined"
        style={{
          paddingLeft: "10px",
          paddingRight: "10px",
          borderRadius: "10px",
        }}
      >
        {HeaderPage()}
        <DataTablePaginationServer
          tableRef={tableRef}
          exportButton={true}
          columns={columns}
          data={documentData}
          page={variable.page}
          totalCount={variable.countRowData}
          width="100%"
          onChangePage={(event, newPage) => {
            variable.page = newPage;
            getData(newPage, variable.pageSize, variable.startDate, variable.endDate, variable.search);
          }}
          onChangeRowsPerPage={(e) => {
            variable.pageSize = e.target.value;
            getData(variable.page, e.target.value, variable.startDate, variable.endDate, variable.search);
          }}
          pageSize={variable.pageSize}
        />
      </Card>
      {openDialogformEdit && (
        <AddDocumentRecordDaily
          onCancel={() => setOpenDialogformEdit(false)}
          open={openDialogformEdit}
          documentId={variable.documentId}
        />
      )}
      {openDialogformAdd && (
        <AddDocumentRecordDaily
          onCancel={() => {setOpenDialogformAdd(false)}}
          open={openDialogformAdd}
          documentId={null}
        />
      )}
      <Loading open={variable.loading} />
    </>
  );
}

export default DocumentRecordDaily;
